export const ORGANIZATION_TYPES = [
  "Startup",
  "Small business",
  "Medium-sized company",
  "Large company",
  "Enterprise",
  "Agency / consulting firm",
  "Government / Public sector",
  "Educational institution",
  "Non-profit organization",
];

export const INDUSTRY_GROUPS = [
  {
    key: "financial_and_regulated",
    label: "Financial and regulated",
    options: [
      "Banking",
      "Fintech",
      "Insurance",
      "Payments",
      "Real estate",
      "Government / Public sector",
    ],
  },
  {
    key: "commerce_and_services",
    label: "Commerce and services",
    options: [
      "Retail",
      "E-commerce",
      "Hospitality",
      "Travel / Tourism",
      "Logistics / Delivery",
      "Professional services",
    ],
  },
  {
    key: "health_education_social_impact",
    label: "Health, education and social impact",
    options: [
      "Healthcare",
      "Wellness / Fitness",
      "Education",
      "E-learning",
      "Public services",
      "Non-profit / NGO",
    ],
  },
  {
    key: "technology_and_media",
    label: "Technology and media",
    options: [
      "Software / SaaS",
      "AI / Automation",
      "Telecommunications",
      "Media",
      "Entertainment",
      "Marketing / Advertising",
      "Gaming",
    ],
  },
  {
    key: "industrial_and_enterprise",
    label: "Industrial and enterprise",
    options: [
      "Manufacturing",
      "Energy",
      "Agriculture / Agritech",
      "Construction",
      "Transportation",
      "Supply chain",
      "Enterprise operations"
    ],
  },
  {
    key: "other",
    label: "Other",
    options: ["Other industry", "Not sure / mixed industry"],
  },
];

export const MAIN_NEEDS = [
  "Build a new digital product",
  "Modernize an existing system",
  "Build a mobile app",
  "Build a web platform",
  "Build backend services or APIs",
  "Integrate existing systems",
  "Add AI / LLM capabilities to an existing product",
  "Define a technical strategy before development",
  "Not sure yet",
];

export const SOLUTION_TYPES = [
  "Mobile application",
  "Web application / SaaS platform",
  "Backend / API platform",
  "AI assistant / chatbot",
  "AI-assisted SDLC transformation",
  "AI enablement for business operations performance",
  "Enterprise system integration",
  "Technical discovery / product strategy",
  "Not sure yet",
];

export const PROJECT_STAGES = [
  "Just an idea",
  "We have a business need but no technical definition yet",
  "We have requirements or a brief",
  "We have designs / Figma",
  "We have a prototype",
  "We have an MVP",
  "We have an existing product in production",
  "The project is blocked or underperforming",
  "We need technical assessment before deciding",
];

export const TECHNICAL_TEAM_STATUS = [
  "No, we need full delivery",
  "Yes, but we need external support",
  "Yes, we need architecture / technical leadership",
  "Yes, we need mobile specialists",
  "Yes, we need backend/cloud specialists",
  "Yes, we need AI/LLM expertise",
  "Yes, but the project is blocked",
  "We work with vendors and need independent assessment",
  "We are not sure",
];

export const TECHNICAL_SCOPE_OPTIONS = [
  "Cloud infrastructure",
  "System integration",
  "Databases",
  "Authentication / SSO",
  "DevOps / CI-CD",
  "Monitoring / observability",
];

export const AI_SCOPE_OPTIONS = [
  "AI / LLM integrations",
  "AI-assisted SDLC transformation",
  "AI enablement for business operations performance",
  "AI assistants / chatbots",
  "AI workflow automation",
  "Document processing",
  "Recommendation engines",
  "Retrieval-augmented generation / RAG",
  "Customer-facing AI"
];

export const TIMELINE_OPTIONS = [
  "Immediately / urgent",
  "Within the next month",
  "In the next 2-3 months",
  "This quarter",
  "This year",
  "We are planning for next year",
  "We are only exploring options",
];

export const INVESTMENT_RANGE_VALUES = [
  "under_10k",
  "10k_30k",
  "30k_75k",
  "75k_150k",
  "150k_300k",
  "300k_plus",
  "not_defined",
  "prefer_discuss",
];

export const ENGAGEMENT_TYPES = [
  "Fixed-scope project",
  "Discovery phase before development",
  "MVP development",
  "Long-term product development",
  "Time & materials",
  "Technical consultancy",
  "Staff augmentation",
  "Monthly retainer",
  "Not sure yet",
];

export const LANGUAGE_OPTIONS = [
  { code: "en", label: "English" },
  { code: "es", label: "Spanish" },
  { code: "pt", label: "Portuguese" },
  { code: "fr", label: "French" },
  { code: "de", label: "German" },
  { code: "it", label: "Italian" },
  { code: "ja", label: "Japanese" },
];

export const COUNTRY_OPTIONS = [
  { code: "US", label: "United States" },
  { code: "CA", label: "Canada" },
  { code: "MX", label: "Mexico" },
  { code: "BR", label: "Brazil" },
  { code: "AR", label: "Argentina" },
  { code: "CL", label: "Chile" },
  { code: "UY", label: "Uruguay" },
  { code: "GB", label: "United Kingdom" },
  { code: "IE", label: "Ireland" },
  { code: "DE", label: "Germany" },
  { code: "ES", label: "Spain" },
  { code: "FR", label: "France" },
  { code: "IT", label: "Italy" },
  { code: "PT", label: "Portugal" },
  { code: "NL", label: "Netherlands" },
  { code: "SE", label: "Sweden" },
  { code: "AE", label: "United Arab Emirates" },
  { code: "SA", label: "Saudi Arabia" },
  { code: "IN", label: "India" },
  { code: "JP", label: "Japan" },
  { code: "CN", label: "China" },
  { code: "SG", label: "Singapore" },
  { code: "AU", label: "Australia" },
  { code: "NZ", label: "New Zealand" },
  { code: "ZA", label: "South Africa" },
  { code: "NG", label: "Nigeria" },
  { code: "Global", label: "Global / Multi-region" },
];

export const COUNTRY_TO_REGION = {
  US: "North America",
  CA: "North America",
  MX: "Latin America",
  BR: "Latin America",
  AR: "Latin America",
  CL: "Latin America",
  UY: "Latin America",
  GB: "United Kingdom and Ireland",
  IE: "United Kingdom and Ireland",
  DE: "Europe",
  ES: "Europe",
  FR: "Europe",
  IT: "Europe",
  PT: "Europe",
  NL: "Europe",
  SE: "Europe",
  AE: "Middle East",
  SA: "Middle East",
  IN: "Asia-Pacific",
  JP: "Asia-Pacific",
  CN: "Asia-Pacific",
  SG: "Asia-Pacific",
  AU: "Oceania",
  NZ: "Oceania",
  ZA: "Africa",
  NG: "Africa",
};

export const COUNTRY_TO_CURRENCY = {
  US: "USD",
  CA: "USD",
  MX: "USD",
  BR: "USD",
  AR: "USD",
  CL: "USD",
  UY: "USD",
  GB: "GBP",
  IE: "EUR",
  DE: "EUR",
  ES: "EUR",
  FR: "EUR",
  IT: "EUR",
  PT: "EUR",
  NL: "EUR",
  SE: "EUR",
  IN: "INR",
  JP: "JPY",
  CN: "CNY",
  AU: "AUD",
};

export const CURRENCY_SYMBOLS = {
  USD: "USD",
  EUR: "EUR",
  GBP: "GBP",
  JPY: "JPY",
  CNY: "CNY",
  INR: "INR",
  AUD: "AUD",
};

export const INVESTMENT_LABELS_BASE = {
  under_10k: "Under 10k",
  "10k_30k": "10k - 30k",
  "30k_75k": "30k - 75k",
  "75k_150k": "75k - 150k",
  "150k_300k": "150k - 300k",
  "300k_plus": "300k+",
  not_defined: "Not defined yet",
  prefer_discuss: "Prefer to discuss",
};

export const DEFAULT_DISCOVERY_VALUES = {
  organization_type: "",
  industry_group: "",
  industry: "",
  declared_country: "",
  declared_region: "",
  is_multi_region_project: false,
  main_needs: [],
  solution_type: [],
  solution_category: "",
  project_stage: "",
  technical_team_status: "",
  technical_scope: [],
  platforms: [],
  enterprise_systems: [],
  ai_scope: [],
  timeline: "",
  urgency_level: "",
  investment_range: "",
  currency: "USD",
  engagement_type: "",
  business_goal_description: "",
  company_name: "",
  contact_treatment: "",
  contact_name: "",
  contact_role: "",
  email: "",
  phone: "",
  preferred_contact_method: "Email",
  preferred_language: "en",
  timezone: "",
};

export const DISCOVERY_STEPS = [
  { key: "organization_type", type: "single", title: "Organization Type", question: "What type of organization are you representing?" },
  { key: "industry", type: "industry", title: "Industry", question: "Which industry best describes your organization?" },
  { key: "region", type: "region", title: "Project Region", question: "Where is this project mainly based?" },
  { key: "main_needs", type: "multi", title: "Main Business Need", question: "What do you need help with?", options: MAIN_NEEDS },
  { key: "solution_type", type: "multi", title: "Type of Solution", question: "Which solution types best match your initiative?", options: SOLUTION_TYPES },
  { key: "project_stage", type: "single", title: "Project Stage", question: "Where is the project today?", options: PROJECT_STAGES },
  { key: "technical_team_status", type: "single", title: "Technical Team", question: "Do you already have a technical team?", options: TECHNICAL_TEAM_STATUS },
  { key: "technical_scope", type: "scope", title: "Technical Depth", question: "Which technical depth areas should we prioritize?" },
  { key: "timeline", type: "single", title: "Timeline", question: "When would you like to move forward?", options: TIMELINE_OPTIONS },
  { key: "investment_range", type: "investment", title: "Investment Range", question: "Do you already have an investment range in mind?" },
  { key: "engagement_type", type: "single", title: "Engagement Type", question: "What type of engagement are you considering?", options: ENGAGEMENT_TYPES },
  { key: "business_goal_description", type: "textarea", title: "Business Goal", question: "What are you trying to achieve?" },
  { key: "contact", type: "contact", title: "Contact Details", question: "Where should we send your project assessment?" },
  { key: "summary", type: "summary", title: "Smart Summary", question: "Please review your project profile before submission." },
];

export const getRegionFromCountry = (countryCode) => {
  if (!countryCode || countryCode === "Global") {
    return "Global / Multi-region";
  }
  return COUNTRY_TO_REGION[countryCode] || "Global / Multi-region";
};

export const getCurrencyFromCountry = (countryCode) => {
  if (!countryCode || countryCode === "Global") {
    return "USD";
  }
  return COUNTRY_TO_CURRENCY[countryCode] || "USD";
};

export const getInvestmentOptions = (currencyCode) => {
  const symbol = CURRENCY_SYMBOLS[currencyCode] || currencyCode || "USD";
  return INVESTMENT_RANGE_VALUES.map((value) => {
    if (value === "not_defined" || value === "prefer_discuss") {
      return { value, label: INVESTMENT_LABELS_BASE[value] };
    }

    const base = INVESTMENT_LABELS_BASE[value];
    const formatted = base
      .replace("Under ", `Under ${symbol} `)
      .replace("+", "+")
      .replace(" - ", ` - ${symbol} `);

    if (value === "300k_plus") {
      return { value, label: `${symbol} 300k+` };
    }

    return { value, label: formatted };
  });
};

export const deriveUrgencyFromTimeline = (timeline) => {
  const value = (timeline || "").toLowerCase();
  if (value.includes("urgent") || value.includes("immediately")) {
    return "high";
  }
  if (value.includes("next month") || value.includes("2-3 months")) {
    return "medium";
  }
  if (value.includes("exploring") || value.includes("next year")) {
    return "low";
  }
  return "medium";
};

export const getCountryLabel = (code) => {
  const found = COUNTRY_OPTIONS.find((country) => country.code === code);
  return found ? found.label : code;
};
